(function() {
    'use strict';

    window.bbw = {
        startedAt: new Date(),
        model: {},
        service: {chat: {}, uploader: {}},
        directive: {},
        filter: {},
        guest: {
            controller: {}
        },
        main: {
            controller: {}
        },
        admin: {
            controller: {}
        },
        shared: {
            controller: {}
        },
        defaultTitle: 'BBWDREAM',
        isDevelMode: !!document.documentElement.getAttribute('data-devel'),
        appRevision: document.documentElement.getAttribute('data-rev'),
        isSysErr: !!document.documentElement.getAttribute('data-err'),
        userId: (function(el) {
            if (el.hasAttribute('data-uid')) {
                var uid = parseInt(el.getAttribute('data-uid'));
                return isNaN(uid) ? undefined : (uid > 0 ? uid : undefined);
            }
        })(document.documentElement),
        userIsModerator: (function(el) {
            return !!el.getAttribute('data-um');
        })(document.documentElement),
        userIsLocked: (function(el) {
            return !!el.getAttribute('data-ul');
        })(document.documentElement),
        userGender: (function(el) {
            return el.getAttribute('data-gender');
        })(document.documentElement),
        updateRevision: function(rev) {
            if (rev != bbw.appRevision) {
                bbw.appRevision = rev;
                return true;
            } else {
                return false;
            }
        }
    };

    var wrapResourceUrl = [
        function(url) {
            return url;
        },
        function(url) {
            return '/force-no-cache/' + Math.random().toString(32).substr(2) + url;
        }
    ][+bbw.isDevelMode];

    bbw.pageUrl = function(url) {
        return url + '&?'[+!~url.indexOf('?')] + '_=' + bbw.appRevision;
    };

    bbw.templateUrl = function(url) {
        return wrapResourceUrl('/resources/partials/' + url);
    };

    bbw.event = {
        USER_OWN_AVATAR_CHANGED: 'bbw.userOwnAvatarChanged',
        USER_OWN_PHOTOS_COUNT_CHANGED: 'bbw.userOwnPhotosCountChanged',
        USER_POST_ADDED: 'bbw.userPostAdded',
        USER_NICKNAME_CHANGED: 'bbw.userNicknameChanged',
        NEW_FEEDBACK: 'bbw.newFeedback',
        FEED_COUNT: 'bbw.feedCount'
    };

    bbw.configuration = {
        api: {
            rpc_url: '/api/',
            upload_url: '/api/user/photos/upload'
        },
        chat: {
            ws_url: window.location.protocol.replace(/^http/, 'ws') + '//' + window.location.host + '/ws/chat/',
            attached_photos_limit: 5
        },
        post: {
            attached_photos_limit: 10
        },
        smiley: {
            url: '/img/sm/s{0}.gif',
            isSmileyUri: function(uri) {
                return uri.match(/^\/img\/sm\/s([a-z]+)\.gif$/);
            },
            marker_start: '\u200B',
            marker_end: '\u200B'
        },
        intimateStubUrl: '/img/intimate.png',
        photos: {
            accept: {
                maxSizeMb: 50,
                mimeRegexp: /^image\//,
                extensions: [
                    'jpg',
                    'jpeg',
                    'png',
                    'gif',
                    'bmp',
                    'tif',
                    'tiff'
                ]
            }
        },
        age: {
            min: 18,
            max: 65
        },
        weight: {
            min: 40,
            max: 200,
            step: 5,
            suffix: 'кг'
        },
        height: {
            min: 150,
            max: 220,
            step: 5,
            suffix: 'см'
        }
    };

    bbw.contactFolderTitles = {
        main: 'Общая папка',
        fav: 'Избранное',
        trash: 'Корзина'
    };

    bbw.messages = {
        internal_error: 'Внутренняя ошибка',
        success: 'Запрос выполнен успешно',
        saved: 'Изменения сохранены',
        enter_creds: 'Введите e-mail и пароль',
        bad_creds: 'Неверный e-mail или пароль',
        network_error: 'Ошибка связи с сервером. Проверьте подключение к интернету',
        admin: 'Администрация сайта',
        email_exists: 'Такой e-mail уже зарегистрирован',
        email_not_changed: 'Введенный e-mail совпадает с текущим',
        file_size_exceeds: 'Размер файла {0} превышает {1} Мб',
        file_dim_exceeds: 'Изображение в файле {0} превышает допустимые размеры',
        file_dim_low: 'Изображение в файле {0} слишком маленькое. Минимальный размер: 500x325',
        file_is_empty: 'Файл {0} пуст',
        file_is_not_image: 'Файл {0} не является изображением',
        file_is_unknown_image: 'Не распознан формат файла {0}',
        file_album_capacity_exceeded: 'В альбом можно загрузить не более {0} фото',
        chat_attach_limit_exceeded: 'К одному сообщению можно прикрепить не более {0} фото',
        token_expired: 'Сессия истекла. Обновите страницу',
        token_mismatch: 'Сессия истекла. Обновите страницу',
        session_expired: 'Сессия истекла',
        want_relations: {
            values: ['love', 'intim', 'friends'],
            short: {
                love: 'Серьезные отношения',
                friends: 'Дружеские отношения',
                intim: 'Интимные отношения'
            },
            long: {
                love: 'Серьезные отношения, любовь, семья',
                friends: 'Дружеские отношения, общение, переписка',
                intim: 'Интимные отношения, флирт, секс'
            }
        },
        any_location: 'не важно',
        post_too_late_to_edit: 'Время редактирования истекло',
        post_not_editable_after_moderation: 'Сообщение уже одобрено администрацией сайта, редактирование невозможно',
        current_user_is_locked: 'Ваш аккаунт заблокирован администрацией сайта',
        user_is_banned: 'Аккаунт удален за нарушение Соглашения о предоставлении услуг',
        user_is_deleted: 'Аккаунт пользователя удален',
        validation_error: 'Форма заполнена некорректно',
        example: 'Например: ',
        city_example: 'Москва',
        select_city: 'Выберите город',
        select_location: 'Выберите местоположение',
        password_mismatch: 'Неверный пароль',
        password_changed: 'Пароль изменен',
        wrong_otp: 'Неверный код',
        text_required: 'Введите текст сообщения',
        photo_required: 'Добавьте фото',
        area_required: 'Выберите раздел',
        subject_required: 'Введите тему',
        contact_added: 'Пользователь добавлен в общую папку',
        wink_sent: 'Вы подмигнули пользователю',
        not_found: 'Контент не найден',
        access_denied: 'Нет доступа',
        user_not_found: 'Пользователь не найден',
        post_not_found: 'Пост не найден',
        bulk_message_enqueued: 'Сообщение добавлено в очередь рассылки',
        direct_mail_enqueued: 'Рассылка запущена',
        websockets_not_supported: 'Браузер не поддерживает технологию WebSockets, почта отключена',
        searchable_on: 'Ваша анкета появится в поиске в течение 15 минут',
        searchable_off: 'Ваша анкета будет удалена из поиска в течение 15 минут',
        unmoderated: 'На модерации',
        abuse_sent: 'Жалоба отправлена',
        post_hidden: 'Сообщение скрыто',
        post_approved: 'Сообщение одобрено',
        cannot_send_abuse_to_himself: 'Нельзя отправлять жалобу на самого себя',
        post_is_closed: 'Тема закрыта администрацией сайта',
        post_was_reopened: 'Тема открыта',
        cannot_complain_about_admin: 'Нельзя жаловаться на администрацию сайта',
        cannot_comment_rel_banned: 'Пользователь заблокировал вас',
        cannot_like_rel_banned: 'Пользователь заблокировал вас',
        cannot_subscribe_rel_banned: 'Пользователь заблокировал вас',
        cannot_post_without_avatar: 'Публикация без фото в анкете не разрешена',
        cannot_like_without_avatar: 'Требуется фото в анкете',
        cannot_like_own: 'Нельзя установить "мне нравится" на собственный контент',
        subscribed_user: 'Вы подписались на события пользователя',
        unsubscribed_user: 'Вы отменили подписку на события пользователя',
        user_post_limit_exceeded: 'Не разрешается публикация {0} более {1} сообщений в сутки',
        only_admin_can_toggle_intimate_album_photos: 'Это фото - из фотоальбома, устанавливать флаг интимности может только администрация сайта',
        admin_only_area: 'Раздел только для администрации',
        cannot_subscribe_to_own_content: 'Нельзя подписаться на самого себя',
        cannot_unsubscribe_from_own_post: 'Нельзя отписаться от собственного контента',
        contest_max_images: 'На конкурс можно загрузить максимум {0} фото',
        contest_photos_limit_exceeded: 'На конкурс можно загрузить максимум 3 фото',
        contest_participation_application_is_over: 'Прием заявок на конкурс окончен',
        contest_participation_too_late_to_delete: 'Нельзя удалить заявку: конкурс начался',
        contest_user_not_eligible_to_participate: 'Вы не можете участвовать в этом конкурсе',
        contest_user_not_eligible_to_vote: 'Вы не можете голосовать в этом конкурсе',
        contest_vote_is_over: 'Конкурс завершен',
        contest_participant_has_no_photo: 'Нельзя участвовать в конкурсе без фото в анкете',
        contest_application_deleted: 'Ваша заявка на участие в конкурсе удалена',
        contest_application_submitted: 'Заявка на участие в конкурсе подана',
        limit_exceeded: 'Лимит превышен',
        user_post_limit_type: {
            forum: 'в обсуждениях',
            wall: 'на стене',
            blog: 'в дневнике'
        },
        post_type_what: {
            forum: 'тему',
            wall: 'пост',
            blog: 'запись'
        },
        profile_area: {
            profile: 'Анкета',
            photos: 'Фото',
            privateAlbum: 'Привет-альбом',
            wall: 'Стена',
            talk: 'Обсуждения',
            blog: 'Дневник'
        },
        sn: {
            vk: 'ВКонтакте',
            ok: 'Одноклассники',
            facebook: 'Facebook',
            twitter: 'Twitter'
        },
        title: {
            conversations: 'Мои сообщения: {0}',
            chat: 'Мои переписки: {0}'
        },
        chat: {
            wink: {
                incoming: 'Пользователь проявляет к вам симпатию и интерес, но, видимо, стесняется написать первым. Если он тоже вам понравился, проявите инициативу и начните общение.',
                outgoing: 'Вы подмигнули пользователю'
            },
            deny: {
                incoming: 'Пользователь по каким-то причинам не хочет продолжать общение с вами. Возможно, вы не в его вкусе или не соответствуете критериям его поиска. Не расстраивайтесь, это нормальная ситуация, попробуйте найти другого.',
                outgoing: 'Вы вежливо отказали пользователю в дальнейшем общении с вами. Если вы передумали, можете написать ему снова, и тогда он сможет вам отвечать, а ваша переписка с ним будет автоматически перемещена из корзины в общую папку.'
            },
            ban: {
                incoming: 'Пользователь заблокировал для вас возможность дальнейшей переписки с ним и ограничил ваш доступ к его анкете и фотоальбому.',
                outgoing: 'Вы заблокировали пользователю возможность переписки с вами и ограничили его доступ к вашей анкете и фотоальбому. Если вы передумали, можете написать ему снова, и тогда он сможет вам отвечать, а ваша переписка с ним будет автоматически перемещена из корзины в общую папку.'
            },
            ppa1: {
                incoming: 'Пользователь разрешил вам отправлять ему приватные фото',
                outgoing: 'Вы разрешили пользователю отправлять вам приватные фото'
            },
            ppa0: {
                incoming: 'Пользователь запретил вам отправлять ему приватные фото',
                outgoing: 'Вы запретили пользователю отправлять вам приватные фото'
            },
            recp_disallows_private_photos: {
                you: 'Собеседник запретил вам отправлять ему приватные фото',
                default: 'Собеседник запретил отправлять ему приватные фото'
            },
            errors: {
                bad_sender: 'Ваш аккаунт удален',
                bad_recp: 'Аккаунт пользователя удален',
                locked_admin: 'Аккаунт пользователя заблокирован администрацией сайта',
                locked_admin_sender: 'Ваш аккаунт заблокирован администрацией сайта',
                denied_by_recp: 'Вам вежливо отказано в общении',
                photo_required_by_recp: 'Пользователь не хочет общаться с теми, кто не загрузил фото',
                new_contacts_limit_exceeded: 'Вы не можете заводить более {0} новых контактов в сутки',
                recp_disallows_private_photos: 'Собеседник запретил отправлять ему приватные фото',
                internal_error: 'Ошибка сервера'
            },
        },
        contestGender: {
            m: 'парни',
            f: 'девушки',
            p: 'пары'
        },
        contestStatus: {
            draft: "черновик",
            gather: "сбор заявок",
            running: "идет",
            finished: "окончен",
            archive: "в архиве",
            cancelled: "отменен"
        },
        rulesTypes: {
            blog: "Блог",
            wall: "Стена",
            forum: "Обсуждения",
            ppub: "Фото",
            ppriv: "Приват-альбом",
            z_ln_u: "Лендинг/пользователи",
            z_ln_w: "Лендинг/стена",
            z_ln_f: "Лендинг/обсуждения",
            z_ln_a: "Лендинг/о сайте",
            a_dnt_h: "Поддержать проект",
            a_dnt_l: "Поддержать проект: лимит",
        },
        abuse: {
            photo: 'чужое фото',
            flood: 'тема для другого раздела/уход от темы/флуд',
            harrasment: 'непристойные предложения или фото',
            rude: 'грубость, оскорбления, угрозы',
            spam: 'спам, реклама',
            other: 'другая причина'
        },
        admin_message: {
            lock: {
                on: {
                    prefix: 'Ваш аккаунт заблокирован по следующей причине:',
                    suffix: ''
                },
                off: 'Ваш аккаунт разблокирован.'
            },
            error_new_contacts_limit_too_low: 'Лимит должен быть больше, чем значение по умолчанию'
        }
    };

    bbw.browser = bbwBrowser();

    moment.locale('ru');

    if (typeof Raven !== 'undefined') {
        Raven.config('https://c9cf508221b84d41b238f4003ff2cc4c@raven.bbwdream.com/2', {
            release: window.bbw.appRevision
        }).install();
        Raven.setUserContext({id: bbw.userId});
    }
})();
